module.exports = __webpack_public_path__ + "img/img_4.a5393e95.svg";